/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transcode-layer.vue?vue&type=template&id=0b490ab0&scoped=true&"
import script from "./transcode-layer.vue?vue&type=script&lang=ts&"
export * from "./transcode-layer.vue?vue&type=script&lang=ts&"
import style0 from "./transcode-layer.vue?vue&type=style&index=0&id=0b490ab0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b490ab0",
  null
  
)

export default component.exports